import { BasketWholesale } from 'Lib/basket-wholesale/basket-wholesale';
import { eventSender } from 'Lib/event-sender/event-sender';

const elParent = document.querySelector('.wholesale-btn');
const htmlBtnAdd = '<div class="book-page__wholesale-btn-add btn btn_small btn_border-orange"><span class="book-page__wholesale-btn-text">Купить оптом</span><svg class="book-page__wholesale-btn-loader" style="display: none;"><use xlink:href="#loading-motion"></use></svg></div>';
const htmlBtnLinkPlaceOrder = '<a href="/cart/opt/" class="wholesale-btn__btn-place-order btn btn_small btn_border-orange">Оформить</a>';
const basketWholesale = new BasketWholesale(elParent?.getAttribute('data-nomcode'));

if (elParent) {
    basketWholesale.getCurrentBookPage().then((data) => {
        const message = data?.MESSAGE;
        const price = Number(message?.PRICE?.PRICE_OPT?.replace(',', '.'));
        const priceNoDiscount = Number(message?.PRICE?.PRICE_OPT_NO_DISCOUNT?.replace(',', '.'));
        // eslint-disable-next-line no-nested-ternary
        const priceDefault = price && !Number.isNaN(price) ? price : priceNoDiscount && !Number.isNaN(priceNoDiscount) ? priceNoDiscount : '';

        elParent?.insertAdjacentHTML('afterBegin', `
            <div class="r20"></div><div class="r"></div>
            <hr>
            <div class="r20"></div><div class="r"></div>

            <div class="text text_s15 text_lh-1-3 text_bold">Оптовым покупателям</div>
            <div class="r10"></div><div class="r"></div>

            ${data.STATUS ? `
                ${message?.MIN_COUNT ? `<div class="text text_s15 text_lh-1-3">Минимальное количество книг для заказа — ${Number(message.MIN_COUNT.replace(',', '.')).toFixed(0)} шт.</div><div class="r10"></div><div class="r"></div>` : ''}

                <div class="colflex colflex_left colflex_margin-min">
                    ${priceDefault ? `<div class="colflex__item text text_bold text_s24-d text_s20 text_lh-1-5">${priceDefault.toFixed()} ₽&nbsp;</div>` : ''}
                    <div class="colflex__item">
                        ${Number(message?.COUNT) ? htmlBtnLinkPlaceOrder : htmlBtnAdd}
                    </div>
                </div>
            ` : `
                <a href="/personal/0/opt_client/" class="wholesale-btn__btn-place-order wholesale-btn__btn-place-order_link-reg btn btn_small btn_border-orange">Купить оптом</a>
            `}
        `);

        document.querySelector('body').addEventListener('click', (e) => {
            if (e.target.classList.contains('wholesale-btn__btn-place-order_link-reg')) {
                eventSender.customYM({
                    'click': {
                        'click_opt_client': {
                            'link': document.location.href,
                            'title': document.querySelector('title').textContent,
                        },
                    },
                });
            }
        });
    });

    document.querySelector('body').addEventListener('click', (e) => {
        const target = e.target;
        const elParentEvent = target.classList.contains('book-page__wholesale-btn-add') || target.closest('.book-page__wholesale-btn-add');

        if (elParentEvent) {
            document.querySelector('.book-page__wholesale-btn-loader').setAttribute('style', 'display: block');
            document.querySelector('.book-page__wholesale-btn-text').setAttribute('style', 'display: none');

            basketWholesale.addCurrentBookPage().then(() => {
                elParentEvent.insertAdjacentHTML('afterEnd', htmlBtnLinkPlaceOrder);
                elParentEvent.remove();
            });
        }
    });
}